export const routes = {
  connect: {
    path: '/',
  },
  swap: {
    path: '/swap',
  },
  buy: {
    path: '/buy',
  },
  kyc: {
    path: '/kyc',
  },
};
